import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const SideNavTop = () => {
  const { currentUser } = useSelector((state) => state.auth);
  return (
    <Link
      to={`/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`}
      className="side-nav-link"
    >
      <i className="dripicons-meter"></i>
      <span> Dashboard </span>
    </Link>
  );
};

export default SideNavTop;
